import api from '../utils/request';

const referralApi = {
  getOrCreateMyInviteCode: async (inviterId) => {
    const response = await api.get(`/invite-code/my/${encodeURIComponent(inviterId)}`);
    return response.data;
  },

  recordReferral: async ({ inviteCode, inviterId, inviterName, invitedId, invitedName }) => {
    const response = await api.post('/referral/record', {
      invite_code: inviteCode,
      inviter_id: inviterId,
      inviter_name: inviterName,
      invited_id: invitedId,
      invited_name: invitedName,
    });
    return response.data;
  },

  getStats: async (inviterId) => {
    const response = await api.get(`/referral/stats/${encodeURIComponent(inviterId)}`);
    return response.data;
  }
};

export default referralApi;


